import { useCallback } from 'react';
import { useMarkApplicationsAsViewedMutation } from 'shared/hooks/api/markApplicationsAsViewed/markApplicationsAsViewed.generated';
import { useUnviewedApplicationCountQuery } from 'shared/hooks/api/unviewedApplicationCount/unviewedApplicationCount.generated';
import { useApplicationCountStore } from 'shared/hooks/stores/useApplicationCountStore';

export const useApplicationCount = (skipInitialFetch = false) => {
  const setCount = useApplicationCountStore((store) => store.setCount);

  const { refetch } = useUnviewedApplicationCountQuery({
    fetchPolicy: 'no-cache',
    onCompleted: ({ unviewedApplicationCount }) => setCount(unviewedApplicationCount || 0),
    skip: skipInitialFetch,
  });

  const [markApplicationsAsViewedMutation] = useMarkApplicationsAsViewedMutation();

  const markApplicationsAsViewed = useCallback(async (jobOrderIds: string[]) => {
    const res = await markApplicationsAsViewedMutation({
      variables: {
        jobOrderIds,
      },
    });
    const updatedCount = res.data?.markApplicationsAsViewed;
    if (typeof updatedCount === 'number') {
      setCount(updatedCount);
    }
  }, []);

  return {
    markApplicationsAsViewed,
    refreshApplicationCount: refetch,
  };
};
